// SessionManagement.js
import React from "react";
import IdleTimer from "react-idle-timer"; // v4 default export
import { millisToMinutesAndSeconds } from "../../lib/utils";
import store from "../../store";
import { setUserLeaveTimestamp } from "../../actions/userActions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";

const stateMap = (store) => ({
    userReducer: store.userReducer,
});

class SessionManagement extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            remainingTime: null,
            lastActive: null,
        };

        this.idleTimer = null;
        this.onIdle = this._onIdle.bind(this);
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.handleLoad = this.handleLoad.bind(this);
    }

    // Checks if the saved "leave" timestamp or idle last-active time exceeds the timeout
    checkIfTimeoutHasPassed(isIdleTimer) {
        const timeToCompare = isIdleTimer
            ? this.idleTimer != null
                ? this.idleTimer.getLastActiveTime()
                : null
            : this.props.userReducer
                ? this.props.userReducer.userLeaveTimestamp
                : null;

        if (timeToCompare != null) {
            const beforeTimeout = new Date();
            beforeTimeout.setMilliseconds(
                beforeTimeout.getMilliseconds() - this.props.timeout
            );
            if (beforeTimeout.getTime() >= timeToCompare) {
                this.props.handleLogout();
            }
        }
    }

    componentDidMount() {
        // Ensure we log out if timeout already passed before mount
        this.checkIfTimeoutHasPassed(false);
        this.checkIfTimeoutHasPassed(true);

        // Start remaining-time ticker if the ref is ready
        if (this.idleTimer) {
            this.setState({ remainingTime: this.idleTimer.getRemainingTime() });
            this.myInterval = setInterval(() => {
                this.setState({ remainingTime: this.idleTimer.getRemainingTime() });
            }, 1000);
        }

        // Persist "leave" timestamp on tab/browser close
        window.addEventListener("beforeunload", this.handleBeforeUnload);
        // Re-check on load in case timeout elapsed while the app was closed
        window.addEventListener("load", this.handleLoad);
    }

    componentWillUnmount() {
        clearInterval(this.myInterval);
        this.checkIfTimeoutHasPassed(true);
        window.removeEventListener("beforeunload", this.handleBeforeUnload);
        window.removeEventListener("load", this.handleLoad);
    }

    _onIdle(_e) {
        this.props.handleLogout();
    }

    handleBeforeUnload = (_ev) => {
        store.dispatch(setUserLeaveTimestamp(new Date().getTime()));
    };

    handleLoad = () => {
        this.checkIfTimeoutHasPassed(false);
    };

    render() {
        this.checkIfTimeoutHasPassed(true);
        const timeOut = this.props.timeout;

        // Browser guard: do not touch localStorage in Node/build context
        const isBrowser =
            typeof window !== "undefined" &&
            typeof window.localStorage !== "undefined";

        // v4 compatibility: safest fallback is `undefined` to disable cross-tab
        // in non-browser environments (e.g., Node during build).
        // If you want to force a non-localStorage strategy when supported,
        // replace the fallback with `{ type: 'broadcast', emitOnAllTabs: true }`.
        const crossTab = isBrowser
            ? { type: "localStorage", emitOnAllTabs: true }
            : undefined;

        return (
            <IdleTimer
                ref={(ref) => {
                    this.idleTimer = ref;
                }}
                crossTab={crossTab}
                onIdle={this.onIdle}
                timeout={timeOut}
            >
                <span>{millisToMinutesAndSeconds(this.state.remainingTime)}</span>
            </IdleTimer>
        );
    }
}

export default withRouter(connect(stateMap)(SessionManagement));